import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import styles from "./CustomLoader.module.css";

const CustomLoader = ({
  label,
  fallbackLabel = "Generating with Gemini AI",
  size = "md",
  variant = "overlay",
  tone = "primary",
  labelColor,
  backdrop = true,
  className = "",
  style,
  children,
}) => {
  const { translations } = useSelector((state) => state.language);
  const t = useMemo(() => translations?.labels || {}, [translations?.labels]);

  const resolvedLabel = label ?? t?.generatingWithAi ?? fallbackLabel;

  const wrapperClasses = [
    styles.wrapper,
    variant === "inline" ? styles.inline : styles.overlay,
    variant === "overlay" && !backdrop ? styles.noBackdrop : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const spinnerClasses = [
    styles.spinner,
    styles[`spinner_${size}`] || "",
    tone === "neutral" ? styles.spinnerNeutral : styles.spinnerPrimary,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={wrapperClasses}
      role="status"
      aria-live="polite"
      aria-busy="true"
      style={style}
    >
      <div className={spinnerClasses} aria-hidden="true" />
      <div
        className={styles.label}
        style={labelColor ? { color: labelColor } : undefined}
      >
        {resolvedLabel}
      </div>
      {children ? <div className={styles.extra}>{children}</div> : null}
    </div>
  );
};

export default CustomLoader;
